export default __webpack_public_path__ + "slices/main/assets/public/media/default_og_image.7c8237bbf8c4aabe3b2651845c44197f.png";